import { PropsWithChildren, PropsWithRef, ReactNode, forwardRef } from 'react';

interface BroadcastLiveWebinarLayoutProps {
    children: ReactNode;
}

export const BroadcastLiveWebinarLayout = forwardRef<PropsWithRef<HTMLDivElement>, PropsWithChildren<BroadcastLiveWebinarLayoutProps>>(
    ({ children }: BroadcastLiveWebinarLayoutProps, ref) => (
        <div
            ref={ref}
            className="grid grid-rows-[auto_auto_1fr_auto] grid-cols-1 bc:grid-rows-[auto_auto_auto_1fr] bc:grid-cols-[minmax(250px,25%)_52%_1fr] bc:gap-1 h-screen h-dvh"
        >
            {children}
        </div>
    )
);
